import React from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/Card'
import { Button } from '../components/ui/Button'
import { Home, AlertCircle } from 'lucide-react'
import { Link } from 'react-router-dom'

export const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-alt py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <AlertCircle className="mx-auto h-12 w-12 text-muted" />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-primary">
            Page Not Found
          </h2>
          <p className="mt-2 text-center text-sm text-secondary">
            The page you're looking for doesn't exist.
          </p>
        </div>
        <Card>
          <CardHeader>
            <CardTitle>404 - Page Not Found</CardTitle>
            <CardDescription>
              The requested page could not be found.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Link to="/">
              <Button>
                <Home className="h-4 w-4 mr-2" />
                Go Home
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}